import { ROVO_CHAT_CLIENT_ID } from '@atlassian/rovo-content-bridge-api-commands';
import { InlineInputBoxAbortMessageCommand } from '@atlassian/rovo-content-bridge-api-commands/commands/inline-input-box-abort-message-command';

import { CONFLUENCE_DATABASE_CLIENT_ID } from '@canvas/databases-bridge-api';
import { client } from '@canvas/rovo-content-bridge-api';

import { bridgeEventEmitter } from '../bridge-command-emitter';
import { DatabaseStreamState } from '../database-stream-state';

/**
 * Aborts the current Rovo LLM stream for databases. Stops local stream state
 * and asks AFM (Rovo chat) to cancel any in-flight LLM requests via the
 * shared bridge event emitter. Use this when the user clicks a stop button
 * mid-stream.
 */
export const abortDatabaseStream = (contentId: string): void => {
  DatabaseStreamState.getInstance().abortStreaming();
  bridgeEventEmitter.sendEvent(InlineInputBoxAbortMessageCommand, {
    senderId: client(`${CONFLUENCE_DATABASE_CLIENT_ID}-${contentId}`),
    receiverId: ROVO_CHAT_CLIENT_ID
  });
};
